export const ModelRef = [
    {
        ref: 'Darvehei, P., Bahri, P. A., & Moheimani, N. R. (2018). Model development for the growth of microalgae: A Review. Renewable and Sustainable Energy Reviews, 97, 233–258. https://doi.org/10.1016/j.rser.2018.08.027 ',
    },
    {
        ref: 'Dauta, A., Devaux, J., Piquemal, F., & Boumnich, L. (1990). Growth rate of four freshwater algae in relation to light and temperature. Hydrobiologia, 207(1), 221–226. https://doi.org/10.1007/bf00041459 ',
    },
    {
        ref: 'Eilers, P. H. C., & Peeters, J. C. H. (1988). A model for the relationship between light intensity and the rate of photosynthesis in phytoplankton. Ecological Modelling, 42(3-4), 199–215. https://doi.org/10.1016/0304-3800(88)90057-9',
    },
    {
        ref: 'Halmi, M. I. E., Shukor, M. S., Johari, W. L. W., & Shukor, M. Y. (2014). Modeling the growth kinetics of Chlorella vulgaris cultivated in microfluidic devices. Asian Journal of Plant Biology, 2(1), 7–10. https://doi.org/10.54987/ajpb.v2i1.82 ',
    },
    {
        ref: 'Lehman, J. T., Botkin, D. B., & Likens, G. E. (1975). The assumptions and rationales of a computer model of phytoplankton population dynamics1. Limnology and Oceanography, 20(3), 343–364. https://doi.org/10.4319/lo.1975.20.3.0343 ',
    },
    {
        ref: "Zwietering, M. H., Jongenburger, I., Rombouts, F. M., & van 't Riet, K. (1990). Modeling of the bacterial growth curve. Applied and Environmental Microbiology, 56(6), 1875–1881. https://doi.org/10.1128/aem.56.6.1875-1881.1990 ",
    },
]